module.exports = __webpack_public_path__ + "img/illustration-4.3289c278.svg";